import { useContext } from "react";
import UploadyContext from "./UploadyContext";
import assertContext from "./assertContext";

var useUploadyContext = function () {
  return assertContext(useContext(UploadyContext));
};

export default useUploadyContext;